module.exports = __webpack_public_path__ + "static/media/matilde-hat-sri-lanka-sleepy.cee3f4e9.png";